import React from 'react';
import HrPerformanceReview from '../admin/HrPerformanceReview';

const SuperAdminPerformance = () => <HrPerformanceReview variant="superadmin" />;

export default SuperAdminPerformance;
